import React, { useMemo } from 'react';
import SwitchComponent from '../Device-settings/Switch.component';
import ModalComponent from '@ui/components/Modal/Modal.component';
import ButtonComponent from '@ui/components/Button/Button.component';
import ButtonBarComponent from '@ui/components/Button-bar/Button-bar.component';
import ModalFormComponent from '@ui/components/Modal-form/Modal-form.component';
import useDictionary from '@ui/hooks/useDictionary';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    lang,
    loading,
    rights,
    serverError,
    selectedSubuser,
    selectedDevice,
    devices,
    onSaveClick,
    onSendCommandsChange,
    onSettingsChange,
    onCancelClick,
    onBtnKeyDown,
}: IProps) => {
    const getWord = useDictionary();

    const title = useMemo(() => {
        const [device] = devices.filter(({ imei }) => imei === selectedDevice);
        return `${getWord('editSubuserRightsTitle')} "${
            device?.name
        }" ${getWord('fromSubuser').toLowerCase()} "${selectedSubuser}"`;
    }, [lang, devices, selectedDevice, selectedSubuser]);

    return (
        <ModalComponent
            className="edit-subuser-rights"
            title={title}
            alertText={serverError ? 'serverError' : undefined}
            lang={lang}
            loading={loading}
            onBtnKeyDown={onBtnKeyDown}
            onClose={onCancelClick}
        >
            <ModalFormComponent>
                <SwitchComponent
                    alarmState={rights.send_commands}
                    name={'sendCommands'}
                    onAlarmStateChange={onSendCommandsChange}
                />
                <SwitchComponent
                    alarmState={rights.change_settings}
                    name={'changeSettings'}
                    onAlarmStateChange={onSettingsChange}
                />
            </ModalFormComponent>
            <ButtonBarComponent>
                <ButtonComponent
                    label="save"
                    lang={lang}
                    onClick={onSaveClick}
                    onKeyDown={onBtnKeyDown}
                />
                <ButtonComponent
                    color="error"
                    label="cancel"
                    lang={lang}
                    onClick={onCancelClick}
                    onKeyDown={onBtnKeyDown}
                />
            </ButtonBarComponent>
        </ModalComponent>
    );
};

const EditSubuserRightsComponent = React.memo(Component);

export default EditSubuserRightsComponent;
